(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sereine-customer-stories"] && !Shopify.designMode) return;
  try {
    
function continuousSlider(host, track) {
  const signalController = new AbortController();
  const signal = signalController.signal;
  const originals = Array.from(track.children);
  originals.forEach(slide => {const copy=slide.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.inert=true;copy.dataset.duplicate='true';track.append(copy);});
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  let position=track.scrollLeft;
  let resumeAt=0;
  let frame, last=0, hovered=false, touching=false, inView=false;

  const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;},{threshold:0.15});observer.observe(track);
  track.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')hovered=true;},{signal});
  track.addEventListener('pointerleave',()=>hovered=false,{signal});
  track.addEventListener('pointerdown',()=>touching=true,{signal});
  window.addEventListener('pointerup',()=>{touching=false;resumeAt=performance.now()+2500;},{signal});
  window.addEventListener('pointercancel',()=>{touching=false;resumeAt=performance.now()+2500;},{signal});
  function tick(now){
    const elapsed=last?Math.min(now-last,50):0;last=now;
    const duplicate=track.querySelector('[data-duplicate]');
    const distance=duplicate.getBoundingClientRect().left-originals[0].getBoundingClientRect().left;
    if(now>=resumeAt&&inView&&!document.hidden&&!reduce.matches&&!hovered&&!touching&&!track.contains(document.activeElement)&&distance>0){
      position=(position+elapsed*0.012)%distance;
      track.scrollLeft=position;
    }else{position=track.scrollLeft;}
    frame=requestAnimationFrame(tick);
  }
  frame=requestAnimationFrame(tick);
  return ()=>{cancelAnimationFrame(frame);signalController.abort();observer.disconnect();track.querySelectorAll('[data-duplicate]').forEach(x=>x.remove());};
}

if(!customElements.get('sereine-story-slider')){customElements.define('sereine-story-slider',class extends HTMLElement{connectedCallback(){this.cleanup?.();this.cleanup=continuousSlider(this,this.querySelector('.sereine-stories__track'));}disconnectedCallback(){this.cleanup?.();}});}

  } catch(e) { console.error(e); }
})();
})();
